import cn from 'clsx'

// Components
import { Link } from '@tracklib/kit'

// Types
import type { CmsPageCategory } from 'types'

import styles from './categories.css'

type Props = {
  categories: Array<CmsPageCategory>
  className?: string
  showAll?: boolean
}

const ArticleCategories = ({ categories, className = '', showAll = false }: Props): JSX.Element | null => {
  if (!categories) {
    return null
  }
  return (
    <ul className={cn(styles.categories, className)}>
      {showAll && (
        <li key="all">
          <Link to="/blog/all/" style={{ color: '#424242' }}>
            <span className={styles.background} />
            <span>All</span>
          </Link>
        </li>
      )}
      {categories &&
        categories.length &&
        categories.map(x => (
          <li key={x.id}>
            <Link to={encodeURI(`/blog/category/${x.slug}/`).toLowerCase()} style={{ color: x.color }}>
              <span
                className={cn(styles.background, (x.color === '#fff' || x.color === '#ffffff') && styles.blackBackground)}
                style={{ backgroundColor: x.color }}
              />
              <span>{x.name}</span>
            </Link>
          </li>
        ))}
    </ul>
  )
}

export default ArticleCategories
